import { render, staticRenderFns } from "./EmployeePublicInfo.vue?vue&type=template&id=0035da12"
import script from "./EmployeePublicInfo.vue?vue&type=script&lang=js"
export * from "./EmployeePublicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports